import FetchHelper from '../helpers/OldFetchHelper';
import config from '../../config';
import LocalStorageHelper from '../helpers/OldLocalStorageHelper';
import OldErrorHandlerHelper from '../helpers/OldErrorHandlerHelper';

export default {
  async checkForPartnerShop() {
    const data = await this.getPartnerShopInformation();
    if(data) {
      this.isPartnerShop = true;

      this.partnerShopInformation = data;
    }
  },
  async fetchPartnerShopInformationAndRedirectIfNope(hostname) {
    // already fetching? await this promise
    if(FetchHelper.fetchingPartnerDataPromise) {
      await FetchHelper.fetchingPartnerDataPromise;
    }
    if(FetchHelper.didFetchPartnerData) {
      return LocalStorageHelper.getPartnerShopInformation();
    }

    FetchHelper.fetchingPartnerDataPromise = this.$apiService.getPartnerInfo({ params: { name: hostname } });
    const fetchResult = await FetchHelper.fetchingPartnerDataPromise;

    if(fetchResult) {
      if(fetchResult.success) {
        LocalStorageHelper.setPartnerShopInformation(fetchResult.data);
        LocalStorageHelper.setIsPartnerShop(true);
        FetchHelper.didFetchPartnerData = true;
        return fetchResult.data;
      }
      LocalStorageHelper.setIsPartnerShop(false);
      if(fetchResult.error && fetchResult.error === `ERR_NOT_FOUND`) {
        // partner not found, redirect away immediately (no swal here please)
        // window.location = location.protocol + `//` + location.hostname.replace(/.*\.ringana/i, `ringana`);
        return null;
      }
    }

    // something else happened, like the client didn`t wait for the fetch to finish
    OldErrorHandlerHelper.handleError(`PartnerShopMethods, fetchPartnerShopInformation ${fetchResult}`, { logToConsole: true });
    return null;
  },
  async getPartnerShopInformation() {
    const hostname = window.location.hostname.split(`.`)[0];
    if(hostname !== `localhost` && hostname !== `ringana` && hostname !== `www` && hostname !== `ringana-local`) {
      const shopData = await this.fetchPartnerShopInformationAndRedirectIfNope(hostname);

      // prepend the image with its basepath
      if(shopData && shopData.image) {
        shopData.image = `${config.images.paths.imgix}${shopData.image}?auto=format&lossless=1&w=260`;
      }

      return shopData;
    }
    return null;
  },
  setupPartnerShop() {
    // update until possible
    const updateDom = () => {
      if($(`.sidemenu-partnershop, .mobile-menu-partnershop`).length <= 0) return false;
      // legacy stuff
      $(`.sidemenu-partnershop, .mobile-menu-partnershop`).css(`display`, `block`);
      $(`.sidemenu-partnershop a, .mobile-menu-partnershop a`).attr(`href`, `/`);

      // plus some other pages I guess. causes mayhem right now, will have to do better.
      // if ($(`.login-grid`).length > 0) {
      //   // on login page
      //   window.location.href = `/`;
      // }
      return true;
    };

    // will be moved to vue soon (tm). this is horrible.
    window.updatePartnerShopDomCount = 50;
    window.updatePartnerShopDom = setInterval(() => {
      if(window.updatePartnerShopDomCount-- < 0 || updateDom()) {
        clearInterval(window.updatePartnerShopDom);
      }
    }, 100);
  },
};
